// In AuthContext.js
import React, { useContext, useState, useEffect, createContext } from 'react';
import { auth } from './firebaseConfig';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        const userRole = localStorage.getItem('userRole'); 
        const updatedUser = { ...user, role: userRole }; 
        setCurrentUser(updatedUser);
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });
  
    return unsubscribe;
  }, []);
  

  const signOut = () => setCurrentUser(null);

  return (
    <AuthContext.Provider value={{ currentUser, signOut, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
